import React from 'react';
import PublishDateRangeFilter from '@app/components/PublishDateRangeFilter';
import { PlatformTaskFilterData } from '@app/containers/pages/Tasks/types';
import { setPlatformTaskFilterData } from '@app/containers/pages/Tasks/store/events';
import { platformFiltersInformation } from '@app/containers/pages/Tasks/consts';
import { PlatformTaskFilterType } from '@app/containers/pages/Tasks/enums';

export interface TaskPublishDatePlatformFilterProps {
    defaultIsOpen?: boolean;
    platformTaskFilterData: PlatformTaskFilterData;
    onRemove: () => void;
}

export type Props = TaskPublishDatePlatformFilterProps;

const TaskPublishDatePlatformFilter: React.FC<Props> = ({
    defaultIsOpen = false,
    platformTaskFilterData,
    onRemove,
}) => {
    const handleApplyFilter = (publishDateFrom: string | null, publishDateTo: string | null) => {
        setPlatformTaskFilterData({ ...platformTaskFilterData, publishDateFrom, publishDateTo });
    };

    const handleRemoveFilter = () => {
        if (!platformFiltersInformation[PlatformTaskFilterType.TASK_PUBLISH_DATE].isPinned) {
            // Platform task publish date filter is NOT pinned, so it can be removed
            onRemove();
        }
    };

    return (
        <PublishDateRangeFilter
            defaultIsOpen={defaultIsOpen}
            icon={platformFiltersInformation[PlatformTaskFilterType.TASK_PUBLISH_DATE].icon}
            fromDate={platformTaskFilterData.publishDateFrom}
            toDate={platformTaskFilterData.publishDateTo}
            onApply={handleApplyFilter}
            onRemove={handleRemoveFilter}
        />
    );
};

export default TaskPublishDatePlatformFilter;
